import "./style.css";
import 'swiper/css';
import 'swiper/css/pagination';
import "../../Assets/Variable.css";
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { toggleActiveButton } from "@components/Common/ToggleSwitch";
import { signupUser } from "../../API/Auth";
import { success, failed } from "@components/Common/Toastify";
import borrowerImg1 from "../../Assets/Images/borrwr-img-one.png";
import borrowerImg2 from "../../Assets/Images/borrwr-img-two.png";
import borrowerImg3 from "../../Assets/Images/borrwr-img-three.png";
import borrowerImg4 from "../../Assets/Images/borrwr-img-four.png";
import borrowerImg5 from "../../Assets/Images/borrwr-img-five.png";
import { useAppContext } from "../../contexts/AppContextProvider";
import lenderImg1 from "../../Assets/Images/banner-one.png";
import lenderImg2 from "../../Assets/Images/banner-two.png";
import lenderImg3 from "../../Assets/Images/banner-3.png";
import lenderImg4 from "../../Assets/Images/banner-four.png";
import lenderImg5 from "../../Assets/Images/banner-five.png";
import lendriva_logo from "../../Assets/Images/Lendriva_logo.jpg";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import TextInput from "@components/Common/TextInput";
import storage from "@utils/storage";
import PhoneInput from "react-phone-input-2";

export const Signup = () => {
  const navigate = useNavigate();
  const [selectedUserType, setSelectedUserType] = useState<
    "borrower" | "lender"
  >("borrower");
  const borrowerImages = [borrowerImg1, borrowerImg2, borrowerImg3, borrowerImg4, borrowerImg5];
  const { value, setValue } = useAppContext();
  const lenderImages = [lenderImg1, lenderImg2, lenderImg3, lenderImg4, lenderImg5];
  const [, setCurrentImageIndex] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);


  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      password: "",
      confirmPassword: "",
      userType: selectedUserType,
    },
    enableReinitialize: true,

    validationSchema: yup.object({
      firstName: yup
        .string()
        .matches(/^[A-Za-z]+$/, "First name must contain only alphabets")
        .required("First name is required"),
      lastName: yup
        .string()
        .matches(/^[A-Za-z]+$/, "Last name must contain only alphabets")
        .required("Last name is required"),
      email: yup
        .string()
        .email("Invalid email")
        .required("Email is required")
        .matches(/^$|^\S+.*/, "Only blank spaces are not valid."),
      phoneNumber: yup
        .string()
        .required("Phone number is required")
        .matches(/^\+\d{6,15}$/, "Please enter valid phone number. "),
      password: yup.string().required("Password is required").min(5).max(20),
      confirmPassword: yup
        .string()
        .required("Confirm password is required")
        .oneOf([yup.ref("password"), null], "Passwords must match"),
      userType: yup
        .string()
        .oneOf(["lender", "borrower"], "Invalid user type")
        .required("User type is required"),
    }),
    onSubmit: (values) => {
      setBtnLoading(true);
      signupUser(values)
        .then((res: any) => {
          const contextValue = { ...value };
          contextValue.isUser = true;
          contextValue.user = res?.data?.data;
          setValue(contextValue);
          storage.setUserType(res?.data?.data);

          // ✅ Optional: Show success message and prompt for verification
          success(res?.data?.message || "Registration successful. Please verify your phone/email.");

          const verificationUrl = res?.data?.data?.shuftiProVerificationUrl;

          if (verificationUrl) {
            // ✅ Option 1: Redirect automatically
            window.location.href = verificationUrl;

            // ✅ Option 2: OR navigate to a custom verification screen that shows the URL (less aggressive)
            // navigate("/auth/verify-identity", {
            //   state: { verificationUrl },
            // });
          } else {
            navigate("/auth/phone-verification", {
              state: {
                roleType: selectedUserType,
                userData: res?.data?.data,
              },
            });
          }
        })
        .catch((err) => {
          failed(err?.response?.data?.message || "Signup failed.");
          const message = err?.response?.data?.message;
          if (message === "User exists but both phone and document verifications are pending.") {
            navigate("/auth/phone-verification", {
              state: {
                roleType: selectedUserType,
                userData: err?.response?.data?.data,
              },
            });
            return;
          }
          if (message === "User exists but phone number is not verified. Please verify your phone number before proceeding.") {
            navigate("/auth/phone-verification", {
              state: {
                roleType: selectedUserType,
                userData: err?.response?.data?.data,
              },
            });
            return;
          }
          if (message === "User exists but documents are not verified. Please complete document verification.") {
            navigate("/auth/document-verification", {
              state: {
                roleType: selectedUserType,
                userData: err?.response?.data?.data,
              },
            });
            return;
          }
          if(message==="User exists but credit assessment is not completed. Please complete credit assessment."){
            navigate("/auth/credit-score-assessment", {
              state: {
                roleType: selectedUserType,
                userData: err?.response?.data?.data,
              },
            });
            return;
          }
        })
        .finally(() => setBtnLoading(false));
    },

  });

  const handleUserTypeChange = (
    type: "lender" | "borrower",
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setSelectedUserType(type);
    const activeColor = type === "borrower" ? "#111111" : "#111111";

    toggleActiveButton(
      event.currentTarget,
      ".btn-group.switch-btns button",
      activeColor,
      "#c1c1c1ff",
      "#ffffff",
      "#ffffffff",
      (activeType) => {
        const page = document.querySelector(".onboarding-page");
        if (page) {
          page.classList.remove("theme-lender", "theme-borrower");
          page.classList.add(`theme-${activeType}`);
        }
      }
    );
  };

  useEffect(() => {
    const borrowerBtn = document.querySelectorAll(
      ".btn-group.switch-btns button"
    )[0];
    const activeColor = "#111111";
    if (borrowerBtn) {
      toggleActiveButton(
        borrowerBtn as HTMLElement,
        ".btn-group.switch-btns button",
        activeColor,
        "#c1c1c1ff",
        "#ffffff",
        "#ffffffff",
        (activeType) => {
          const page = document.querySelector(".onboarding-page");
          if (page) {
            page.classList.remove("theme-lender", "theme-borrower");
            page.classList.add(`theme-${activeType}`);
          }
        }
      );
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % borrowerImages.length
      );
    }, 5000);
    return () => clearInterval(interval);
  },);

  return (

    <>
      <div className="">
        <div className="onboarding-page signup slider-creatacc-page ">
          {/* <div className="col-lg-6 bg-image p-0">
            <div className="swiper-inner position-relative">
              <Swiper
                pagination={true}
                modules={[Pagination]}
                className="swiper-block"
                onSlideChange={(swiper) => setCurrentImageIndex(swiper.activeIndex)}
              >
                {(selectedUserType === "borrower" ? borrowerImages : lenderImages).map(
                  (imgSrc, index) => (
                    <SwiperSlide key={index}>
                      <div className="slider-images-block">
                        <div className="slider-banner">
                          <img src={imgSrc} alt="" className="img-fluid w-100" />
                        </div>
                        <div className="lendriva-logo-auth position-absolute">
                          <img src={lendriva_logo} alt="" className="img-fluid" />
                        </div>
                        <div className="overlay-content text-center">
                          <h5 className="overlay-heading">Welcome to Lendriva!</h5>
                          <p className="overlay-heading">
                            Empowering Your Financial Journey with Community Support
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                )}
              </Swiper>
            </div>
          </div> */}
          <div className=" p-0 d-flex flex-column my-3">
            <div className="upper-div login-blk align-items-center d-flex justify-content-between mb-3 p-0">
              <div className="return-home">
                <Link to="/" className="return text-decoration-none align-ittems-center d-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 511 511.999"
                    width="18"
                    height="18"
                    style={{ display: 'block', filter: 'brightness(0) invert(1)' }}
                  >
                    <path
                      d="M498.7 222.695c-.016-.011-.028-.027-.04-.039L289.805 13.81C280.902 4.902 269.066 0 256.477 0c-12.59 0-24.426 4.902-33.332 13.809L14.398 222.55c-.07.07-.144.144-.21.215-18.282 18.386-18.25 48.218.09 66.558 8.378 8.383 19.44 13.235 31.273 13.746.484.047.969.07 1.457.07h8.32v153.696c0 30.418 24.75 55.164 55.168 55.164h81.711c8.285 0 15-6.719 15-15V376.5c0-13.879 11.293-25.168 25.172-25.168h48.195c13.88 0 25.168 11.29 25.168 25.168V497c0 8.281 6.715 15 15 15h81.711c30.422 0 55.168-24.746 55.168-55.164V303.14h7.719c12.586 0 24.422-4.903 33.332-13.813 18.36-18.367 18.367-48.254.027-66.633zm-21.243 45.422a17.03 17.03 0 0 1-12.117 5.024H442.62c-8.285 0-15 6.714-15 15v168.695c0 13.875-11.289 25.164-25.168 25.164h-66.71V376.5c0-30.418-24.747-55.168-55.169-55.168H232.38c-30.422 0-55.172 24.75-55.172 55.168V482h-66.71c-13.876 0-25.169-11.29-25.169-25.164V288.14c0-8.286-6.715-15-15-15H48a13.9 13.9 0 0 0-.703-.032c-4.469-.078-8.66-1.851-11.8-4.996-6.68-6.68-6.68-17.55 0-24.234l.019-.02L244.363 35.02A17.003 17.003 0 0 1 256.477 30c4.574 0 8.875 1.781 12.113 5.02l208.8 208.796.098.094c6.645 6.692 6.633 17.54-.031 24.207z"
                      fill="#000000"
                    />
                  </svg>
                  <span className="ms-1 return-home">Home</span>
                </Link>
              </div>
              {/* <div className="dont-have-acc">
                Already have an account?{" "}
                <a href="/auth/login" className="signup">
                  Sign In
                </a>
              </div> */}
            </div>
            <div className="lower-div">
              <div className="credentials-box">
                <div className="btn-group switch-btns d-flex mb-4 mx-0" role="group">
                  <button
                    type="button"
                    className="btn-borrowerr w-100"
                    onClick={(e) => handleUserTypeChange("borrower", e)}
                  >
                    Borrower
                  </button>
                  <button
                    type="button"
                    className="btn-lenderr w-100"
                    onClick={(e) => handleUserTypeChange("lender", e)}
                  >
                    Lender
                  </button>
                </div>
                <div className="heading-para-block">
                  <h2 className="text-center signin-heading ">
                    Sign up
                  </h2>
                  {/* <p className="text-center">
                    Sign up and get started with lendriva community
                  </p> */}
                  {/* <div>
                    <button className='mb-3 w-100 btn-social'><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16" cy="16.5" r="14" fill="#0C82EE" />
                      <path d="M21.2137 20.7816L21.8356 16.8301H17.9452V14.267C17.9452 13.1857 18.4877 12.1311 20.2302 12.1311H22V8.76699C22 8.76699 20.3945 8.5 18.8603 8.5C15.6548 8.5 13.5617 10.3929 13.5617 13.8184V16.8301H10V20.7816H13.5617V30.3345C14.2767 30.444 15.0082 30.5 15.7534 30.5C16.4986 30.5 17.2302 30.444 17.9452 30.3345V20.7816H21.2137Z" fill="white" />
                    </svg>
                      <span className='ms-3'>Sign in with Facebook</span></button>
                  </div> */}
                  {/* <div className='mb-4'>
                    <button className='w-100 btn-social'><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.5005 12.7332C22.5005 11.8699 22.4291 11.2399 22.2744 10.5865H12.2148V14.4832H18.1196C18.0006 15.4515 17.3577 16.9099 15.9291 17.8898L15.9091 18.0203L19.0897 20.435L19.3101 20.4565C21.3338 18.6249 22.5005 15.9298 22.5005 12.7332Z" fill="#4285F4" />
                      <path d="M12.214 23.0001C15.1068 23.0001 17.5353 22.0667 19.3092 20.4567L15.9282 17.89C15.0235 18.5083 13.8092 18.94 12.214 18.94C9.38069 18.94 6.97596 17.1083 6.11874 14.5767L5.99309 14.5871L2.68583 17.0955L2.64258 17.2133C4.40446 20.6433 8.0235 23.0001 12.214 23.0001Z" fill="#34A853" />
                      <path d="M6.12095 14.5767C5.89476 13.9234 5.76386 13.2233 5.76386 12.5C5.76386 11.7767 5.89476 11.0767 6.10905 10.4234L6.10306 10.2842L2.75435 7.7356L2.64478 7.78667C1.91862 9.21002 1.50195 10.8084 1.50195 12.5C1.50195 14.1917 1.91862 15.79 2.64478 17.2133L6.12095 14.5767Z" fill="#FBBC05" />
                      <path d="M12.2141 6.05997C14.2259 6.05997 15.583 6.91163 16.3569 7.62335L19.3807 4.73C17.5236 3.03834 15.1069 2 12.2141 2C8.02353 2 4.40447 4.35665 2.64258 7.78662L6.10686 10.4233C6.97598 7.89166 9.38073 6.05997 12.2141 6.05997Z" fill="#EB4335" />
                    </svg>
                      <span className='ms-3'>Sign in with Google</span></button>
                  </div> */}
                </div>
                {/* <div className="or-divider mb-4">
                  <span>OR</span>
                </div> */}


                <form className="onboarding-form p-0" onSubmit={formik.handleSubmit}>
                  <div className="row mb-4">
                    <div className="col-lg-6 email-name-label">
                      <TextInput
                        keyField="firstName"
                        label="First Name"
                        formik={formik}
                        placeholder="First Name"
                      />
                    </div>
                    <div className="col-lg-6">
                      <TextInput
                        keyField="lastName"
                        label="Last Name"
                        formik={formik}
                        placeholder="Last Name"
                      />
                    </div>
                  </div>

                  <div className="row mb-4">
                    <div className="col-lg-6 email-name-label">
                      <TextInput
                        keyField="email"
                        label="Email"
                        formik={formik}
                        placeholder="Email"
                      />
                    </div>
                    <div className="col-lg-6 phone-number-label ">
                      <label className="form-label">Phone Number</label>
                      <PhoneInput
                        country="gb" // default country code
                        placeholder="Phone Number"
                        value={formik.values.phoneNumber}
                        onChange={(value) => {
                          // Normalize value with '+' prefix if missing
                          const normalized = value.startsWith('+') ? value : `+${value}`;
                          formik.setFieldValue('phoneNumber', normalized);
                        }}
                        onBlur={() => formik.setFieldTouched('phoneNumber', true)}
                        inputProps={{
                          name: 'phoneNumber',
                          required: true,
                          autoFocus: false,
                        }}
                        inputClass={formik.touched.phoneNumber && formik.errors.phoneNumber ? "input-error" : ""}
                      />
                      {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                        <div className="error-message">{formik.errors.phoneNumber}</div>
                      )}
                    </div>
                  </div>

                  <div className="mb-4">
                    <TextInput
                      type="password"
                      keyField="password"
                      label="Password"
                      formik={formik}
                      placeholder="Password"
                    />
                  </div>

                  <div className="mb-4">
                    <TextInput
                      type="password"
                      keyField="confirmPassword"
                      label="Confirm Password"
                      formik={formik}
                      placeholder="Confirm Password"
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-borrower signin w-100 btn-bg"
                    disabled={btnLoading}
                  >
                    {btnLoading ? "Signing Up..." : "Sign Up"}
                  </button>
                  <p className='sign-upp'>Already have an account?
                    <Link
                      to="/auth/login"
                      className="forgot-remember-pw forgot-pw text-decoration-none small text-end ms-2"
                    >
                      Sign In
                    </Link>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
